import React from "react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f8f9fa] px-4 py-8 text-center">
      <h1 className="text-[80px] sm:text-[120px] font-bold text-[#343a40] leading-none m-0">
        404
      </h1>

      <h2 className="text-xl sm:text-2xl text-[#6c757d] my-2">
        Page Not Found
      </h2>

      <p className="text-sm sm:text-base text-[#adb5bd] mb-7 max-w-sm">
        The page you are looking for does not exist or you don't have access.
      </p>

      <div className="flex flex-wrap gap-3 justify-center">
        <button
          onClick={() => window.history.back()}
          className="px-5 py-2.5 text-sm sm:text-base font-semibold bg-[#007bff] text-white rounded-lg hover:bg-[#0069d9] transition active:scale-95"
        >
          Go Back
        </button>
        <button
          onClick={() => (window.location.href = "/login")}
          className="px-5 py-2.5 text-sm sm:text-base font-semibold bg-[#6c757d] text-white rounded-lg hover:bg-[#5a6268] transition active:scale-95"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default NotFound;